export function createMarketViewWorker() {
  return new Worker(new URL("./marketViewLayout.worker.js", import.meta.url));
}
